export function changeTitle(title) {
    let dom = document.querySelector('title')
    if (dom) {
        dom.innerText = title+' - 中文知识网'
    }
}
export function changeKeywords(keywords) {
    let dom = document.getElementsByTagName('meta')['keywords']
    if (dom) {
        dom.setAttribute("content", keywords)
    }
}
export function changeDescription(description) {
    let dom = document.getElementsByTagName('meta')['description']
    if (dom) {
        dom.setAttribute("content", description)
    }
}